/** @format */

import React, { useCallback, useState } from "react";
import "./UserWidget.scss";

import { ReactComponent as AccountIcon } from "bootstrap-icons/icons/person.svg";
import { ReactComponent as Cap } from "bootstrap-icons/icons/mortarboard.svg";
import { ReactComponent as ArrowDownLeft } from "bootstrap-icons/icons/arrow-down-left.svg";
import { ReactComponent as X } from "bootstrap-icons/icons/x.svg";
import { ReactComponent as Person } from "bootstrap-icons/icons/person.svg";
import { ReactComponent as BoxArrowUpRight } from "bootstrap-icons/icons/box-arrow-up-right.svg";
import { ReactComponent as LifePreserver } from "bootstrap-icons/icons/life-preserver.svg";

import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "../../app/hooks";
import { useGetUserQuery } from "../../app/services/userApi";
import { Link, useLocation } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import { useLocale } from "../../i18n/hooks";
import UserAvatar from "./UserAvatar";
import FeatureFlag from "../featureFlag/FeatureFlag";

const UserWidget = () => {
  const isAuthenticated =
    useAppSelector((state) => state.auth.userToken?.token) || false; // useSelector(selectedIsAuthenticated);

  const { t: _ } = useTranslation();
  const location = useLocation();
  const locale = useLocale();
  const { data } = useGetUserQuery(!!isAuthenticated ? undefined : skipToken);
  const [showUserOptions, setShowUserOptions] = useState(false);

  let guideURL;
  switch (data?.role) {
    case "wjec":
      guideURL =
        "http://resource.download.wjec.co.uk/vtc/editable-bl-docs/staff.html";
      break;
    case "teacher":
      guideURL =
        locale === "cy"
          ? "https://resource.download.wjec.co.uk/vtc/editable-bl-docs/athrawon.html"
          : "http://resource.download.wjec.co.uk/vtc/editable-bl-docs/teacher.html";
  }

  const handleUserOptionsToggle = useCallback(() => {
    if (showUserOptions) {
      setShowUserOptions(false);
    } else {
      setShowUserOptions(true);
    }
  }, [showUserOptions]);

  return (
    <>
      <div className="user-widget">
        <>
          <Button
            title="login"
            onClick={handleUserOptionsToggle}
            className="user-options-button"
          >
            {isAuthenticated ? (
              <UserAvatar user={data} />
            ) : (
              // <span className="text-white">{_("login")}</span>
              <Person className="person-icon" title={_("login")} />
            )}
          </Button>
          {showUserOptions && (
            <div className="bg-white border-rounded rounded-3 p-3 user-options-wrapper text-end">
              <div className="text-dark user-dropdown">
                {isAuthenticated ? (
                  <>
                    <div className="user-details item d-flex align-items-center">
                      <UserAvatar user={data} />
                      <p className="m-0">{data?.meta.name}</p>
                      <X
                        className="close ms-3"
                        viewBox="4 4 8 8"
                        onClick={handleUserOptionsToggle}
                      />
                    </div>
                    <div className="user-options pt-3" role="menu">
                      <Link to="/user/account" title="account-link">
                        <AccountIcon fill="#AEAEAE" title="account-icon" />
                        {_("My Account")}
                      </Link>
                      <Link to="/user/dashboard" title="resources-link">
                        <Cap fill="#AEAEAE" title="resources-icon" />
                        {_("My Resources")}
                      </Link>
                      {guideURL && (
                        <Link
                          to={guideURL}
                          target={"_blank"}
                          title="help-support-link"
                        >
                          <LifePreserver fill="#AEAEAE" title="help-icon" />
                          {_("Help & support")}
                          <BoxArrowUpRight
                            fill="#AEAEAE"
                            className="ms-auto me-0 p-2"
                          />
                        </Link>
                      )}
                      <Link
                        to="/auth/logout"
                        state={{ from: location }}
                        replace
                        title="logout-link"
                      >
                        <ArrowDownLeft fill="#AEAEAE" title="logout-icon" />
                        {_("Log Out")}
                      </Link>
                    </div>
                  </>
                ) : (
                  <>
                    <X
                      className="close ms-auto"
                      viewBox="4 4 8 8"
                      onClick={handleUserOptionsToggle}
                    />
                    <div className="user-options" role="menu">
                      <FeatureFlag
                        flag={"hwb"}
                        fallback={
                          <Link to="#" className="btn btn-link disabled">
                            <img
                              src="https://cdn.hwb.gov.wales/hwb-cms/4.34.31/img/hwb-logo.svg"
                              alt="Hwb"
                            />{" "}
                            {_("login")} {_("with")} Hwb
                          </Link>
                        }
                      >
                        <Link
                          to="/auth/hwblogin"
                          state={{ from: location }}
                          replace
                          title="hwb-link"
                        >
                          <img
                            src="https://cdn.hwb.gov.wales/hwb-cms/4.34.31/img/hwb-logo.svg"
                            alt="Hwb"
                          />
                          {_("login")} {_("with")} Hwb
                        </Link>
                      </FeatureFlag>

                      {/* <Link to="/auth/bblogin" state={{ from: location }} replace>
                      {_("Login as staff")}
                    </Link> */}

                      {/* <Link to="auth/login" state={{ from: location }} replace title="bitbucket-link">
                                                <Bitbucket title="bitbucket-icon" />
                                                {_('login')} {_('with')} {_('Bitbucket')}
                                            </Link> */}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </>
      </div>
    </>
  );
};

export default UserWidget;
